<template>
  <div class="manpower">
    <Header @ck="onclick($event)"></Header>
    <slideshow></slideshow>
    <div class="content_manpower">
      <div class="content_manpower_left">
        <div class="rightData_box box1">
          <div class="rightData">
            <div class="business">
              <span class="titlebar">投资者关系</span>

              <div class="arrow-right">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item :to="{ path: '/' }"
                    >你现在所在的位置</el-breadcrumb-item
                  >
                  <el-breadcrumb-item :to="{ path: '/' }"
                    >首页</el-breadcrumb-item
                  >
                  <el-breadcrumb-item>投资者关系</el-breadcrumb-item>
                  
                </el-breadcrumb>
              </div>
            </div>
            <div class="recruitment_manager">
                <div>1.公司公告:<a href="http://www.cninfo.com.cn/new/index">可进入巨潮资讯查询</a></div>
                <div style="margin:20px 0;">2.投资者邮箱：IR@000520.top</div>
            </div>
          </div>
        </div>

        <!-- <el-tab-pane label="员工培训" name="2">
            <div class="rightData_box box2">
              <div class="rightData">
                <div class="business">
                  <span class="titlebar">员工培训</span>
                
                  <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >你现在所在的位置</el-breadcrumb-item
                      >
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                      >
                      <el-breadcrumb-item>人力资源</el-breadcrumb-item>
                      <el-breadcrumb-item>员工培训</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
                <div>
                  <ul class="staffTraining_img">
                    <li v-for="(item, index) in arr" :key="index">
                      <img :src="item.simgurl" alt />
                      <span style="font-size:16px;cursor:pointer" @click="tiaozhuan()">
                        {{ item.title }}
                      </span>
                      <div class="tx"></div>
                    </li>
                  </ul>
                </div>
               
                <el-pagination
                 v-if="this.qw==1"
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
        :current-page="listQuery.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
       <el-pagination
         v-if="this.qw==2"
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
        :current-page="listQuery.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="listQuery.pageSize"
        layout="prev, pager, next,sizes"
        :total="total"
      >
      </el-pagination>
              </div>
            </div>
          </el-tab-pane> -->
        <!-- <el-tab-pane label="投资者邮箱" name="2">
            <div class="rightData_box box3">
              <div class="rightData">
                <div class="business">
                  <span class="titlebar">投资者邮箱</span>
                
                  <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >你现在所在的位置</el-breadcrumb-item
                      >
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                      >
                      <el-breadcrumb-item>投资者关系</el-breadcrumb-item>
                      <el-breadcrumb-item>投资者邮箱</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
                <div class="regulations">
                  <h4>{{ add.title }}</h4>
                  <div class="add_text">
                    {{ add.content }}
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
        <!-- <el-tab-pane label="表格下载" name="4">
            <div class="rightData_box box4">
              <div class="rightData">
                <div class="business">
                  <span class="titlebar">表格下载</span>
                 <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >你现在所在的位置</el-breadcrumb-item
                      >
                      <el-breadcrumb-item :to="{ path: '/' }"
                        >首页</el-breadcrumb-item
                      >
                      <el-breadcrumb-item>人力资源</el-breadcrumb-item>
                      <el-breadcrumb-item>表格下载</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
                <div class="table_download">
                  <ul>
                    <li v-for="(item, index) in table" :key="index">
                      <div class="table_download_box">
                        <div>
                          <img
                            src="../../assets/img/27ec4bf8504d0904d8864b6ebfb1d41.jpg"
                            alt
                          />
                        </div>
                        <span>{{ item.title }}</span>
                      </div>
                      <div class="dianji">
                        <a :href="item.simgurl" style="" >点击下载</a>
                      </div>
                      
                    </li>
                  </ul>
                 
                    <el-pagination
              v-if="this.qw==1"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listy.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="listy.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totals"
      >
      </el-pagination>
      <el-pagination
              v-if="this.qw==2"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listy.pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="listy.pageSize"
        layout="prev, pager, next,sizes"
        :total="totals"
      >
      </el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
      </div>
      <div></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import pagination from "../../components/haed/pagination";
import axios from "axios";
import qs from "qs";
export default {
  name: "manpower",
  components: {
    Header,
    Footer,
    slideshow,
    pagination,
  },
  data() {
    return {
      cur: 1,
      Name: "1",
      listQuery: {
        bsId: "",
        pageNum: 1,
        pageSize: 5,
      },
      listy: {
        pageNum: 1,
        pageSize: 5,
      },
      totals: 4,
      arr: [],
      add: [],
      list: [],
      table: [],
      total: 5,
      tabPosition: "left",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      qw: "",
    };
  },
  created() {
    if (this.windowWidth > 1000) {
      this.qw = 1;
    } else if (this.windowWidth < 1000) {
      this.qw = 2;
    }
    if (this.$route.query.name) {
      this.Name = this.$route.query.name;
    }
    this.stafftraining();
    this.regulations();
    this.employment();
    this.formtoDownload();
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1;
      } else if (that.windowWidth < 1000) {
        this.qw = 2;
      }
    },
  },
  methods: {
    handleSizeChanges() {},
    handleSizeChange() {},
    handleCurrentChanges(val) {
      this.listQuery.pageNum = val;
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 17,
          pageNum: this.listQuery.pageNum,
          pageSize: 5,
        }),
      })
        .then((res) => {
          this.arr = res.data.data;
          this.total = res.data.datanum;
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    handleCurrentChange(val) {
      this.listy.pageNum = val;
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 19,
          pageNum: this.listy.pageNum,
          pageSize: this.listy.pageSize,
        }),
      })
        .then((res) => {
          this.table = res.data.data;
          this.totals = res.data.datanum;
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    onclick(data) {
      console.log("123", data);
      this.Name = data;
    },
    getShowLists() {
      this.stafftraining();
    },
    clickpage() {
      this.formtoDownload();
    },
    tiaozhuan() {},
    stafftraining: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 17,
          pageNum: this.listQuery.pageNum,
          pageSize: 5,
        }),
      })
        .then((res) => {
          this.arr = res.data.data;
          this.total = res.data.datanum;
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    regulations: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 18,
          pageNum: this.listy.pageNum,
          pageSize: 5,
        }),
      })
        .then((res) => {
          this.add = res.data.data[0];
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    employment: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 16,
          // pageNum: 0,
          // pageSize: 5,
        }),
      })
        .then((res) => {
          this.list = res.data.data[0];
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    formtoDownload: function () {
      this.$axios({
        method: "post",
        url: "/index.php/news/newslist",
        data: qs.stringify({
          id: 19,
          pageNum: this.listy.pageNum,
          pageSize: this.listy.pageSize,
        }),
      })
        .then((res) => {
          this.table = res.data.data;
          this.totals = res.data.datanum;
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    // download(){

    // }
  },
};
</script>

<style scoped>
.box4 .dianji a {
  color: #fff;
}
.el-tabs--left .el-tabs__item.is-left {
  padding-right: 20px !important;
}
.el-tabs--left,
.el-tabs--right {
  margin-left: 0;
}
.rightData_box {
  width: 100%;
  margin-top: -3%;
}
.rightData {
  width: 98%;
  /* margin-left: 40px; */
  margin-bottom: 30%;
  /* background-color: #0c47a1; */
}
.add_text {
  font-size: 16px;
}
.ziti {
  font-size: 16px;
}
.arrow-right {
  margin-top: 3%;
}
.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 15px 0;
}
.titlebar {
  font-weight: bold;
  font-size: 32px;
  color: #31518c;
  line-height: 2;
}
.content_m {
  height: 850px;
}
.Figure_img img {
  width: 100%;
  height: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.content_manpower {
  display: flex;
  width: 100%;
  margin-top: 1%;
  /* height: 900px; */
}
.content_manpower_left {
  /* width: 100%; */
  width: 1000px;
  /* margin-left: 10px; */
  margin: auto;
}
.content_manpower_right {
  width: 77%;
  /* height: 750px; */
  margin-left: -10%;
}
.recruitment_manager h2 {
  color: #0647a1;
  text-align: center;
}
.recruitment_message {
  width: 100%;
  background: #0647a1;
  margin: 10px 0;
  line-height: 2;
  display: flex;
}
.recruitment_message span {
  color: #fff;
}
.recruitment_message :nth-child(2) {
  /* margin-left: 39%; */
  margin-left: 10%;
  margin-right: 10%;
}
.recruitment_message :nth-child(4) {
  margin-left: 26%;
}
.lists {
  text-align: center;
  line-height: 2;
  font-size: 16px;
}
.recruitment_bt {
  width: 100px;
  height: 32px;
  background: #0c47a1;
  color: #fff;
  border: none;
  margin-left: 32vw;
  margin-top: 2%;
  margin-bottom: 1%;
}
.IconToShow {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 8%;
}
.IconToShow span {
  display: block;
  text-align: center;
  color: #1e4d9f;
  margin-top: 5px;
}
.staffTraining_img img {
  width: 60%;
}
.staffTraining_img li {
  display: flex;
  margin-top: 2%;
  margin-bottom: 1%;
}
.staffTraining_img li span {
  color: #7e7e7e;
  line-height: 2;
  margin-left: 2%;
}
.tx {
  border-bottom: 1px solid #eee;
  margin: 1.5% 0;
}
.regulations h2 {
  color: #989898;
  margin: 10px 0;
}
.regulations div {
  line-height: 2;
  color: #989898;
  font-size: 16px;
}
.table_download ul li {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 22px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
}
.table_download button {
  width: 100px;
  height: 34px;
  border: none;
  color: #fff;
  background: #0c47a1;
  margin-top: 1.5vw;
}
.table_download_box {
  width: 20%;
  display: flex;
}
.dianji {
  width: 72px;
  height: 20px;
  padding: 10px;
  display: inline-block;
  background: #eee;
  text-align: center;
  border-radius: 5px;
  background-color: #3e75ff;
  color: #fff;
  margin-bottom: 2%;
}
.table_download_box span {
  margin-top: 12%;
  margin-left: 2%;
}
.block2 {
  margin-top: 60px;
  text-align: center;
}

.slash {
  text-align: center;
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  line-height: 1.9vw;
  height: 1.9vw;
}
.rli {
  text-align: center;
  display: block;
}
.crumbs {
  display: flex;
}
.crumbs span {
  color: #969696;
}

.el-row {
  padding-left: 5%;
}
.el-submenu .el-menu-item {
  min-width: 1px;
}
.el-breadcrumb {
  line-height: 1.5;
  font-size: 16px;
}
.Pagination_box {
  text-align: center;
  margin-top: 5%;
}
.pagination-container {
  text-align: center;
  margin-top: 2%;
}
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .content_manpower_left {
    width: 100%;
  }
  .box1 {
    margin-top: 1%;
  }
  .box1 .recruitment_message span {
    font-size: 12px;
  }
  .box1 .recruitment_message .rs {
    margin-left: 18px;
    margin-right: 18px;
  }
  .box1 .cst {
    margin-left: 6%;
  }
  .box1 .business {
    display: none;
  }
  .rightData {
    width: 96%;
    margin-left: 10px;
    margin-right: 10px;
  }
  .box2 {
    margin-top: 1%;
  }
  .box2 .business {
    display: none;
  }
  .box2 .staffTraining_img li img {
    width: 200px;
    height: 192px;
  }
  .box2 .staffTraining_img li span {
    height: 192px;
    overflow: hidden;
  }
  .box3 {
    margin-top: 1%;
  }
  .box3 .business {
    display: none;
  }
  .box3 .add_text {
    /* font-size: 14px; */
  }
  .box3 .regulations h4 {
    font-size: 22px;
  }
  .box4 {
    margin-top: 1%;
  }
  .box4 .business {
    display: none;
  }
  .box4 .table_download_box {
    width: 50%;
  }
  /* .box4 .dianji{
    margin-bottom: -4%;
  } */
  .table_download_box img {
    width: 50px;
    height: 60px;
  }
  .table_download_box span {
    font-size: 14px;
  }
  .box4 .dianji {
    margin-bottom: -15%;
    padding: 10px;
    width: 70px;
    height: 20px;
    margin-top: 2%;
  }
  .box4 .dianji a {
    color: #fff;
  }
}
</style>
<style>
.manpower .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff;
}
.cst {
  margin-left: 1px;
}
</style>
<style>
.el-tabs--left,
.el-tabs--right {
  /* margin-left: 5%; */
  margin-top: 20px;
}
.el-tabs__item {
  padding: 0;
}
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
  padding-right: 20px !important;
}
.el-pagination {
  margin-bottom: 1%;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .manpower .el-tabs--left .el-tabs__item.is-left {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/manpower/manpower.vue